import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";

import { addNewItem } from "../../apis/cartsApiSlice";

const Product = ({ product }) => {
  const dispatch = useDispatch();

  const starRatings = (rating) => {
    const rateElements = [];
    const rate = Math.round(rating);

    for (let i = 1; i < 6; i++) {
      rateElements.push(
        <span key={i}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill={i < rate ? "#000" : "none"}
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="w-6 h-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M11.48 3.499a.562.562 0 011.04 0l2.125 5.111a.563.563 0 00.475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 00-.182.557l1.285 5.385a.562.562 0 01-.84.61l-4.725-2.885a.563.563 0 00-.586 0L6.982 20.54a.562.562 0 01-.84-.61l1.285-5.386a.562.562 0 00-.182-.557l-4.204-3.602a.563.563 0 01.321-.988l5.518-.442a.563.563 0 00.475-.345L11.48 3.5z"
            ></path>
          </svg>
        </span>
      );
    }

    return rateElements;
  };

  return (
    <div className="flex flex-col items-start w-full xs:w-[calc(50%-16px)] sm:w-[calc(33.33%-22px)] lg:w-[calc(25%-24px)] p-4 shadow-lg">
      <div className="w-full flex items-center justify-center h-[300px]">
        <img
          className="w-auto max-h-full"
          src={product.image}
          alt={product.title}
        />
      </div>
      <div className="flex flex-col min-h-[calc(100%-300px)]">
        <h4 className="text-lg mt-4 mb-4">{product.title}</h4>
        <div className="inline-flex items-center">
          {starRatings(product?.rating.rate)}
        </div>
        <p className="text-lg mt-4 mb-6">$ {product.price.toFixed(2)}</p>
        <div className="flex items-center gap-8 mt-auto mb-0">
          <button className="bg-secondary py-4 px-6 rounded-md" onClick={(e) => { dispatch(addNewItem(product.id)); }}>
            Add to Cart
          </button>
          <Link className="underline cursor-pointer" to={`/all_products/${product.id}`}>More details</Link>
        </div>
      </div>
    </div>
  );
};

export default Product;
